import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router-dom";
import "./home.css";
import Popular from "./Popular";
import TopRated from "../Components/TopRated";
import Upcoming from "../Components/Upcoming";
import Footer from "./Footer";
import Design1 from "../Designs/Design1";
import Sliders from "../Designs/Sliders";
import Trending from "../Designs/Trending";
import TrendingPages from "../Designs/TrendingPages";

const Home = () => {
  const [popularMovies, setPopularMovies] = useState([]);

  useEffect(() => {
    fetch(
      "https://api.themoviedb.org/3/movie/upcoming?api_key=375735221c3b7b45a786c79616eae571&language=en-US"
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.results);
        setPopularMovies(data.results);
      });
  }, []);

  return (
    <>
      {/* <div className="poster">
        <Carousel
          className="main-carousel"
          showThumbs={false}
          autoPlay
          interval={"2000"}
          transitionTime={3}
          infiniteLoop={true}
          showStatus={false}
          swipeable={false}
          showIndicators={false}
        >
          {popularMovies.slice(0, 12).map((movie) => {
            return (
              <div key={movie.id} className="carousel">
                <div className="caro-image">
                  <img
                    className="images"
                    src={`https://image.tmdb.org/t/p/original${movie.backdrop_path}`}
                    alt="movie"
                  />
                </div>
                <div className="carousel-content">
                  <div className="movie-title">
                    <Link
                      style={{ textDecoration: "none" }}
                      to={`movie/${movie.id}`}
                      className="title"
                    >
                      {movie.original_title}
                    </Link>
                  </div>
                  <div className="all-content">
                    <div className="date-and-rating">
                      <p className="date">{movie.release_date}</p>
                      <i className="fa fa-star"> {movie.vote_average}</i>
                    </div>
                    <div className="desc">
                      <p className="movie-desc">{movie.overview}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div> */}

      <div className="poster">
        <Carousel
          className="main-carousel"
          showThumbs={false}
          autoPlay
          interval={"2000"}
          transitionTime={3}
          infiniteLoop={true}
          showStatus={false}
          swipeable={false}
          showIndicators={false}
        >
          {popularMovies.slice(0, 12).map((movie) => {
            return (
              <div
                style={{
                  backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.6) 40%, transparent 50%), url(
                    https://image.tmdb.org/t/p/original${movie.backdrop_path}
                  )`,
                }}
                key={movie.id}
                className="carousel"
              >
                <div className="new-caro-overlay"></div>
                <div className="caro-image">
                  {/* <img
                    className="images"
                    src={`https://image.tmdb.org/t/p/original${movie.backdrop_path}`}
                    alt="movie"
                  /> */}
                </div>
                <div className="new-caro-carousel-content">
                  <div className="new-caro-movie-title">
                    <Link
                      style={{ textDecoration: "none" }}
                      to={`movie/${movie.id}`}
                      className="new-caro-title"
                    >
                      {movie.original_title}
                    </Link>
                  </div>
                  <div className="new-caro-all-content">
                    <div className="new-caro-date-and-rating">
                      <p className="new-caro-date">{movie.release_date}</p>
                      <i className="fa fa-star"> {movie.vote_average}</i>
                    </div>
                    <div className="new-caro-desc">
                      <p className="new-caro-movie-desc">
                        {movie.overview.slice(0, 100)}...
                      </p>
                    </div>
                    <div className="new-caro-button">
                      <Link to={`movie/${movie.id}`}>Watch Now</Link>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>

      <Design1 />
      <Sliders title="Popular Movies" popularMovies={popularMovies} />
      <TrendingPages />
      <Trending />

      <Upcoming />
    </>
  );
};

export default Home;
